export const headerBackGroundColor = "#5d98cf";
export const headertextColor = "black";
export const headertextAlign = "center";
export const headerborderBottom = "1px solid black";
export const headerborderTop = "1px solid black";

export const tableBackgroundColor = "white";
